import axios from 'axios';

const ApiSendEmail = async (url, formData) => {
     
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/`+ url,
      formData,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data', 
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error sending email with PDF:', error);
    throw error;
  }
};

export default ApiSendEmail;
